import {defineComponent} from "vue"

export default defineComponent({
  computed: {
    homeRoute() {
      return this.$auth.isGuest() ? this.$routeTo(this.ROUTES.HOME) : (this.$auth.isAdmin() ? this.$routeTo(this.ROUTES.USERS) : (this.$auth.isCompany() ? this.$routeTo(this.ROUTES.COMPANY_DASHBOARD) : this.$routeTo(this.ROUTES.FIND_WORK)))
    }
  }
})
